<template>
    <v-form ref="form">
    <v-layout row wrap>
    <v-flex xs12 md5>
    <v-layout column>
    <v-flex ma-2>
        <v-card>
          <v-card-title>{{ $t('application.new') }}</v-card-title>
            <v-card-text>
                <p>
                    <span class='tag caption'>{{ $t('application.competition') }}</span>
                    <span>
                      <v-select 
                        :items="this.$store.getters['competitions']" :label="$t('ctrl.selectCompetition')" 
                        v-model="selectedCompetition" hide-details
                        solo item-text="title" item-value="id" class="pt-4"/>
                    </span>
                </p>
                <VAlert :value="cycle == null && hasCycles" type="error" transition="scale-transition" >{{ $t("application.noCycleForApplicationType") }}</VAlert>
                <VAlert :value="!hasCycles" type="error" transition="scale-transition" >{{ $t("application.noCycle") }}</VAlert>
                <v-text-field :label="$t('application.title')" name="search" type="text" v-model="application.Title" :rules="[rules.required]" v-if="this.application.applicationCompetitors.length > 1" />
                <v-checkbox
                  v-model="application.invoiceForDepartment" color="red"
                  :label="$t('application.invoiceForDepartment')"
                ></v-checkbox>
                <v-text-field :label="$t('application.invoiceAddress')" type="text" 
                  v-model="application.InvoiceAddress" v-if="application.invoiceForDepartment" />
                <v-text-field :label="$t('application.taxNumber')" type="text" 
                  v-model="application.TaxNumber" v-if="application.invoiceForDepartment" />
                <v-textarea
                    name="input-7-1"
                    :label="$t('application.remarks')"
                    v-model="application.Remarks"
                    rows="3"
                    ></v-textarea>
            </v-card-text>
        </v-card>
    </v-flex>
    <v-flex ma-2>
        <v-card>
          <v-card-title>{{ $t('application.summary') }}</v-card-title>
            <v-card-text>
                <p>
                    <span class='tag caption'>{{ $t('application.type') }}</span>
                    <span>{{ applicationType }}</span>
                </p>
                <p v-if="cycle != null && cycle.paymentByTransfer">
                    <span class='tag caption'>{{ $t('application.price') }}</span>
                    <span>{{ cycle.amount }} €</span>
                </p>
            </v-card-text>
            <VAlert :value="error" type="error" transition="scale-transition" >
              {{ $t("application.failed") }}
            </VAlert>
            <VAlert :value="duplicate" type="error" transition="scale-transition" >
              {{ $t("application.duplicateError") }}
            </VAlert>
            <VAlert :value="duplicateTitle" type="error" transition="scale-transition" >
              {{ $t("application.duplicateTitleError") }}
            </VAlert>
            <VAlert :value="incomplete" type="error" transition="scale-transition" >
              {{ $t("application.incomplete") }}
            </VAlert>
            <v-card-actions>
            <v-btn color="green" :disabled="cycle==null || pending" @click="submitApplication">{{$t('ctrl.submit')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
    </v-layout>
    </v-flex>
    <v-flex xs12 md7>
    <v-layout column>
    <v-flex ma-2>
        <v-card>
          <v-card-title>{{ $t('application.competitors') }}</v-card-title>
            <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="this.application.applicationCompetitors"
                  hide-default-headers
                  hide-default-footer
                  class="elevation-1"
                  disable-pagination
                  dense
                >
                  <template v-slot:item="{item}">
                    <tr>
                      <td>
                        {{ item.competitor.firstName }}
                        {{ item.competitor.lastName }}
                      </td>
                      <td>{{ item.competitor.department }}</td>
                      <td>
                        <v-btn v-if="!item.competitor.me" text icon color="red" @click="removeCompetitor(item)">
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-text-field prepend-icon="person" name="search" 
                    :label="$t('profile.search')" type="text" v-if="this.application.applicationCompetitors.length < 5"
                    :rules="[rules.email]" :disabled="searching"
                    append-icon="add"
                    @keypress="keyPress" v-model="searchTerm"
                    @click:append="search"/>
                <VAlert :value="invalidUser" type="error" transition="scale-transition" v-if="this.application.applicationCompetitors.length < 5" >
                  {{ $t("application.cantAddCompetitor") }}
                </VAlert>
                <v-chip v-for="c in filteredFriends" :key="c" @click="addFriend(c.email)">
                  {{c.firstName}} {{c.lastName}}
                </v-chip>
            </v-card-text>
        </v-card>
    </v-flex>
    </v-layout>
    </v-flex>
    </v-layout>
    </v-form>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VChip,
    VAlert
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'
  import FCCApplicationStatus from '../components/FCCApplicationStatus'
  import FCCApplicationDetails from '../components/application/FCCApplicationDetails'
  import FCCApplicationPayment from '../components/application/FCCApplicationPayment'
  import FCCApplicationCompetitors from '../components/application/FCCApplicationCompetitors'
  import FCCApplicationEvents from '../components/application/FCCApplicationEvents'

  export default {
    name: 'Application',
    data: () => ({
      drawer: null,
      dateofbirth: "",
      application: {
        applicationCompetitors: []
      },
      searchTerm: "",
      searching: false,
      invalidUser: false,
      noCycle: true,
      submitTerms: false,
      error: false,
      duplicate: false,
      duplicateTitle: false,
      incomplete: false,
      pending: false,
      friends: []
    }),
    computed: {
      selectedCompetition: {
        set(id) {
          this.$store.dispatch('selectCompetition', id);
        },
        get(){
          return this.$store.getters['competitionId'];
        }
      },
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
      headers: function(){
        return [
          { text: this.$t('competitor.name'), value: 'name', align: 'left' },
          { text: this.$t('competitor.department'), value: 'department', align: 'left' },
          { text: this.$t('ctrl.remove'), value: '', align: 'left' },
        ];
      },
      cycle: function(){
        var cs = this.$store.getters['competition'].applicationCycles;
        var result = null;
        cs.forEach((c) => {
          if(this.isValidCycle(c)) result = c;
        });
        return result;
      },
      applicationTypeId: function(){
        var count = this.application.applicationCompetitors.length;
        if(count == 1) return 0;
        if(count == 2) return 1;
        return 2;
      },
      applicationType: function() {
        return this.$t('application.'+Array('individual', 'tandem', 'relay')[this.applicationTypeId]);
      },
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required'),
          email: value => {
            if(value == "") return true;
            const pattern = /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/
            return pattern.test(value) || this.$t('registration.invalidEmail')
          }
        }
      },
      hasCycles: function(){
        var cs = this.$store.getters['competition'].applicationCycles;
        return cs.some((cycle) => {
          const start = new Date(cycle.startTime);
          const end = new Date(cycle.endTime);
          const now = new Date();
          return start < now && now < end;
        });
      },
      competitorsEmails: function(){
        return this.application.applicationCompetitors.map(c => c.competitor.email);
      },
      filteredFriends: function(){
        var ce = this.competitorsEmails;
        return this.friends.filter(f => !ce.includes(f.email));
      }
    },
    props: {
      source: String
    },
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VDataTable,
      VTextarea,
      VAutocomplete,
      VCheckbox,
      FCCApplicationStatus,
      FCCApplicationDetails,
      FCCApplicationPayment,
      FCCApplicationCompetitors,
      FCCApplicationEvents,
      VChip,
      VAlert
    },
    methods: {
      addFriend: function(email){
        this.searchTerm = email;
        this.search();
      },
      keyPress(key) {
        if(key.keyCode == 13) this.search();
      },
      removeCompetitor: function(competitor){
        console.log("remove")
        const index = this.application.applicationCompetitors.indexOf(competitor);
        this.application.applicationCompetitors.splice(index, 1);
      },
      search: function(){
          this.searching = true;
          this.invalidUser = false;
          fccapi.post('search', {Term: this.searchTerm}).then((r) => {
            var users = r.data;
            if(users && users.length > 0){
              this.addCompetitor(users[0]);
              this.searchTerm = "";
            }
            else this.invalidUser = true;
            this.searching = false;
          }).catch(e => {
            console.log(e);
            this.searching = false;
            this.invalidUser = true;
          })
      },
      addCompetitor: function(user){
        if(this.application.applicationCompetitors.length > 4) return;
        for(var i = 0; i < this.application.applicationCompetitors.length; i++){
          if(this.application.applicationCompetitors[i].competitor.email == user.email) return;
        }
        this.application.applicationCompetitors.push({
          competitor: user
        });
      },
      submitApplication: function(){
        if(this.$refs.form.validate()){
          this.incomplete = false;
          this.application.competitionId = this.$store.getters['competition'].id;
          this.error = false;
          this.duplicate = false;
          this.duplicateTitle = false;
          this.pending = true;
          fccapi.post("applications/apply", this.application).then(e => {
            this.pending = false;
            console.log(e);
            this.$router.push('/app/applications/'+e.data.id);
          }).catch(e => {
            this.pending = false;
            console.log(e.response);
            if(e.response.status == 422)this.duplicate = true;
            else if(e.response.status == 409) this.duplicateTitle = true;
            else this.error = true;
          });
        }
        else this.incomplete = true;
      },
      isValidCycle: function(cycle){
        const start = new Date(cycle.startTime);
        const end = new Date(cycle.endTime);
        const now = new Date();
        return start < now && now < end && this.applicationTypeId == cycle.applicationType;
      }
    },
    mounted: function(){
      var thisUser = this.$store.getters['user'];
      thisUser.me = true;
      this.application.applicationCompetitors.push({
        competitor: thisUser
      });
      fccapi.get('friends').then(f => {
        this.friends = f.data;
      });
      this.$store.dispatch('loadCompetitions')
    }
  }
</script>